import React from 'react';
import './App.css';

import Starfield from './components/Starfield';
import Header from './components/Header';
import Hero from './components/Hero';
import LiveActivity from './components/LiveActivity';
import StatsGrid from './components/StatsGrid';
import RecentLaunches from './components/RecentLaunches';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';
import { usePublicStream } from './hooks/usePublicStream';

function App() {
  const { status, stats, launches, lastBuyback, isConnected, isMockMode } = usePublicStream();

  return (
    <div className="min-h-screen bg-[#0a0a0f] relative">
      {/* Starfield background */}
      <Starfield />
      
      {/* Header */}
      <Header />
      
      {/* Main content */}
      <main>
        <Hero />
        <RecentLaunches launches={launches} />
        <LiveActivity status={status} latestLaunch={launches?.[0] || null} />
        <StatsGrid stats={stats} />
        <HowItWorks />
      </main>
      
      {/* Footer */}
      <Footer lastBuyback={lastBuyback} isMockMode={isMockMode} />
    </div>
  );
}

export default App;
